import { combineReducers } from 'redux';

// Reducers
import warehouseReducer from './Warehouse/store/warehouseReducer';

export const subComponents = (translations) => [
    { name: translations["warehouses"] || "Warehouses", path: '/warehouses', permissions: ['warehouse_list'] }
]

export const reducers = combineReducers({
    warehouse: warehouseReducer
});

